import React, { forwardRef } from "react";
import { Dialog, DialogContent, Box, Typography, Button, Slide } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const SlideUp = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const CartDeleteDialog = ({ open, onConfirm, onCancel }) => (
  <Dialog
    open={open}
    onClose={onCancel}
    TransitionComponent={SlideUp}
    PaperProps={{
      sx: {
        borderRadius: "16px",
        boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        maxWidth: 340,
        width: "100%",
        mx: 2,
      },
    }}
  >
    <DialogContent sx={{ p: 0 }}>

      {/* Ícono */}
      <Box sx={{ display: "flex", justifyContent: "center", pt: 3, pb: 1.5 }}>
        <Box sx={{
          width: 56, height: 56, borderRadius: "50%",
          bgcolor: "#fef2f2", border: "1.5px solid #fecaca",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <DeleteOutlineIcon sx={{ fontSize: 26, color: "#ef4444" }} />
        </Box>
      </Box>

      {/* Texto */}
      <Box sx={{ px: 3, pb: 3, textAlign: "center" }}>
        <Typography sx={{ fontWeight: 700, fontSize: "1rem", color: "#1e293b", mb: 0.75 }}>
          ¿Eliminar producto?
        </Typography>
        <Typography sx={{ fontSize: "0.82rem", color: "#94a3b8", lineHeight: 1.6 }}>
          Este producto será quitado de tu carrito. Podés volver a agregarlo cuando quieras.
        </Typography>
      </Box>

      {/* Botones */}
      <Box sx={{ display: "flex", gap: 1, px: 2.5, pb: 2.5 }}>
        <Button
          fullWidth
          onClick={onCancel}
          sx={{
            borderRadius: "10px", textTransform: "none",
            fontWeight: 600, fontSize: "0.875rem",
            border: "1.5px solid #e2e8f0", color: "#64748b",
            bgcolor: "#f8fafc",
            "&:hover": { bgcolor: "#f1f5f9", borderColor: "#94a3b8" },
          }}
        >
          Cancelar
        </Button>
        <Button
          fullWidth
          onClick={onConfirm}
          sx={{
            borderRadius: "10px", textTransform: "none",
            fontWeight: 700, fontSize: "0.875rem",
            bgcolor: "#ef4444", color: "#fff",
            "&:hover": { bgcolor: "#dc2626" },
            boxShadow: "0 4px 12px rgba(239,68,68,0.3)",
          }}
        >
          Eliminar
        </Button>
      </Box>

    </DialogContent>
  </Dialog>
);

export default CartDeleteDialog;